import { ERouteHttpVerb } from "@devowl-wp/api";
const routeLocationUserSessionDelete = {
    path: "/user/session",
    method: ERouteHttpVerb.DELETE
};
export { routeLocationUserSessionDelete };
